const Header = () => {
  return (
    <header className="App-header border-black border-solid border-b-4 bg-gray py-6 px-2 shadow-2xl text-center text-5xl">
      Gallery
    </header>
  );
};

export default Header;
